<div class="login-form">
    <div class="logo-dash mb-4">
        <img src="assets/assets/img/logo.png" />
    </div>
    <h2>{{ ttl }}</h2>
    <div class="custom-form mt-2">
        <form [formGroup]="loginGroup" autocomplete="off" method="post">
            <div class="form-row mt-4">
                <div class="form-group col-lg-12">
                    <label for="user" class="p-2">Enter Email ID or Mobile No or User ID.<span class="text-danger star">*</span></label>
                    <div class="input-wrapper w-100">

                        <input type="text" #ss autocomplete="off" formControlName="email_phone" class="form-control" (keyup.enter)="showOtpBtn?sendOtp():false" />
                        <!-- <app-custom-input type="text" autocomplete="off" formControlName="email_phone"></app-custom-input> -->
                        <!-- <label for="user">Enter Email ID or Mobile No.</label> -->
                        <app-show-errors [ctrl]="loginGroup.get('email_phone')">
                        </app-show-errors>
                    </div>
                </div>
            </div>

            <div class="d-flex">
                <div *ngIf="showOtpBtn" class="mt-3 w-100">
                    <button type="button" class="btn login-btn otpBtnBox" (click)="sendOtp()">
          Send OTP
        </button>
                </div>
            </div>
            <ng-container *ngIf="!showOtpBtn">
                <div class="form-row mt-4">
                    <div class="form-group col-lg-12">
                        <div class="input-wrapper w-100">
                            <label class="floating-label-label" for="pass">Password <span class="text-danger star">*</span></label>
                            <div class="password-wrap">
                                <input type="password" id="pass" formControlName="password" class="form-control" autocomplete="new-password" placeholder="" appShowHidePassword />
                            </div>

                            <!-- <div *ngIf="(loginControls['password'].touched || submitted)" class="mt-3">
                        <span class="text-danger" *ngIf="loginControls['password'].errors?.['required']">
                              Password is Required
                            </span>
                    </div> -->
                            <app-show-errors [ctrl]="loginGroup.get('password')">
                            </app-show-errors>
                        </div>
                    </div>
                </div>
                <div class="form-row">
                    <div class="col-lg-12 forgot">
                        <a routerLink="/forgot-password">Forgot Password</a>
                    </div>
                </div>
                <div class="mt-3 w-100" *ngIf="!isOtpBoxShow">
                    <button (click)="loginUser()" class="btn login-btn" [disabled]="loginGroup.invalid">
            Sign In
          </button>
                </div>
            </ng-container>
            <div class="signup">
                New to Cipherpay? <a routerLink="/add-user">Signup</a>
            </div>
        </form>
    </div>
</div>
<!-- OTP Template Modal -->
<ng-template cdkPortal #modalTemplate="cdkPortal">
    <!-- <div class="modal-otp"> -->
    <app-custom-otp [otpBox]="4" [title]="'Verify Mobile Number'" [message]="maskMobileNo"
     [submitBtnName]="'Verify Mobile'" (sendOtp)="verifyOtp($event)" (resendOtp)="sendOTP(true)"
     [submitBtnClass]="'btn btn-primary'" (closeTemplateModal)="closeTemplateModal()"></app-custom-otp>
    <!-- </div> -->
</ng-template>
